/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'loading_split': {
    width: 14,
    height: 11,
    viewBox: '0 0 14 11',
    data: '<g _stroke="#404040" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M.7 10.07h12.442M8.64 6.601h3.332v3.223H8.64zM5.308 6.601H8.64v3.223H5.308zM8.64 3.378h3.332v3.223H8.64zM3.035 1h3.332v3.223H3.035z"/></g>'
  }
})
